angular.module('octopusApp.tenants')
    .directive('advancedTenantSelector', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                availableTenants: '=',
                selectedTenants: '=',
                selectedTags: '=',
                selectedEnvironment: '=',
                hideTenants: '@',
                applyBorder: '@',
                tenantFilter: '&?',
                filterByProjectId: '='
            },
            templateUrl: 'areas/tenants/advanced_tenant_selector/advanced_tenant_selector.html',
            compile: function (element, attrs) {
                if (!attrs.tenantFilter) {
                    attrs.tenantFilter = function () {
                        return null;
                    };
                }
            },
            controller: function ($scope, $uibModal, octopusTagSets, octopusRepository) {
                var vm = this;
                var allTenants = [];
                vm.availableTagSets = {};
                vm.applyBorder = (vm.applyBorder || '').toLowerCase() === "false" ? false : true;
                vm.openTagDesigner = openTagDesigner;
                vm.getAvailableTenants = getAvailableTenants;
                vm.showEmptyMessage = showEmptyMessage;
                vm.matchingTenantText = null;

                function init() {
                    if (!vm.availableTenants && octopusRepository.Tenants) {
                        octopusRepository.Tenants.all().then(function (tenants) {
                            allTenants = tenants;
                        });
                    }

                    octopusTagSets.getAll().then(function (tagSets) {
                        vm.availableTagSets = tagSets.filter(function (ts) {
                            return ts.Tags.length > 0;
                        });
                    });

                    $scope.$watchCollection(function() { return vm.selectedTenants; }, calcMatches);
                    $scope.$watchCollection(function() { return vm.selectedTags; }, calcMatches);
                    $scope.$watchCollection(function() { return vm.selectedEnvironment; }, calcMatches);
                }

                function showEmptyMessage(){
                    return vm.availableTagSets.length === 0 && vm.hideTenants;
                }

                function getAvailableTenants() {
                    return vm.availableTenants || allTenants;
                }

                function openTagDesigner() {
                    $uibModal.open({
                        backdrop: true,
                        keyboard: true,
                        templateUrl: 'areas/tenants/advanced_tenant_selector/design_selected_tags_dialog.html',
                        controller: 'DesignSelectedTagsController',
                        controllerAs: 'vm',
                        bindToController: true,
                        resolve: {
                            selectedValues: function () {
                                return {
                                    selectedTenants: vm.selectedTenants,
                                    selectedTags: vm.selectedTags
                                };
                            },
                            visibleTenantFilter: function () {
                                return function (tenant) {
                                    return checkProjectFilter(tenant) || vm.tenantFilter({tenant: tenant});
                                };
                            },
                            hideTenants: function () {
                                return vm.hideTenants;
                            }
                        }
                    }).result.then(function (result) {
                            if (!result) {
                                return;
                            }
                            vm.selectedTenants = result.selectedTenants;
                            vm.selectedTags = result.selectedTags;
                        });
                }

                function checkProjectFilter(tenant) {
                    if (!vm.filterByProjectId) {
                        return null;
                    }

                    var environments = tenant.ProjectEnvironments[vm.filterByProjectId];
                    if (!environments) {
                        return "Tenant is not connected to this project.";
                    }

                    return null;
                }

                function calcMatches(){
                    if ((!vm.selectedTenants || vm.selectedTenants.length === 0) && (!vm.selectedTags || vm.selectedTags.length === 0)) {
                        vm.matchingTenantText = null;
                        vm.matchingTenantDescription = null;
                    } else {

                        var validTenantIds = getAvailableTenants().filter(function(tenant) {
                            return !(checkProjectFilter(tenant) || vm.tenantFilter({tenant: tenant}));
                        }).map(function(tenant){
                            return tenant.Id;
                        });

                        octopusRepository.Tenants.tagTest(vm.selectedTenants, vm.selectedTags).then(function (result) {
                            var matchCount = vm.getAvailableTenants().reduce(function(sum, tenant) {
                                if (validTenantIds.indexOf(tenant.Id) === -1) {
                                    return sum;
                                }

                                return sum + (result[tenant.Id].IsMatched ? 1 : 0);
                            }, 0);

                            vm.matchingTenantText = matchCount === 1 ?
                                "1 matching tenant" :
                            matchCount + " matching tenants";

                            vm.matchingTenantDescription = "This filter currently results in " + vm.matchingTenantText + ".";
                        });
                    }
                }

                init();
            },
            controllerAs: 'vm',
            bindToController: true
        };
    });



//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/advanced_tenant_selector/advanced_tenant_selector.js
// module id = 619
// module chunks = 1